<template>
  <div>
    <template v-if="lfb_graph_data_loading">
      <h3>
        Calculating LFB sales data ...
      </h3>
    </template>
    <template v-else>
      <h3>LFB relative Sales</h3>
      <div class="row">
          <div class="col-11">
            <div class="graph_background">
                <line-chart ytitle="Sales / Accounts" prefix="%" :dataset="{borderWidth: 3}" :colors="['#1500e8','#4cd9ae','#aa00aa']" :data=lfb_graph_data.graph_data_array></line-chart>
            </div>
          </div>
      </div>
      <div class="row">
        <div class="col-12">
          The {{lfb_graph_data.scale_data.count_lfb_all_involved}} LFB accounts with orders: 100% All Sales = ${{lfb_graph_data.scale_data.amount_all}} | 100% LFB Sales = ${{lfb_graph_data.scale_data.amount_lfb}} | 100% LFB Accounts = {{lfb_graph_data.scale_data.count_lfb}}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      lfb_graph_data: 'admin/lfb_graph_data',
      lfb_graph_data_loading: 'admin/lfb_graph_data_loading',
    }),
  },
  mounted() {
    this.get_lfb_graph_data();
  },
  methods: {
    get_lfb_graph_data () {
      this.$store.dispatch('admin/getLfbGraphData');
    },
  }
}
</script>

<style scoped>

.align_left {
  text-align: left;
}

</style>
